import { ThemeType } from "./baseTheme";
import { createMuiTheme } from "@material-ui/core/styles";

// 'CAH' palette of colors
const primaryColor = "#287BA4"; // White
const secondaryColor = "#ffffff"; // Light Blue
const headerTopBorderColor = "#002855"; // Dark blue
const headerBottomBorderColor = "#FFF";
const mainBackgroundColor = "#E5E5E5"; // Very light gray
const listSelectionColor = "#F5F5F5"; // Not so light gray
const footerColor = "#FAFAFA"; // Black
const footerTextColor = `${secondaryColor}`;
const footerTopBorderColor = "#c9c9c9"; // Very light gray
const searchButtonBorderRadius = "2px";
const listItemHoverColor = "#FAFAFA";

// Links for header
const contactUsLink = "https://www.connectbyamfam.com/help/contact-us/";
const logoLink = "https://www.connectbyamfam.com/";
// Links for Footer
const companyInformation = "https://www.connectbyamfam.com/about-us/";
const termsAndConditions = "https://www.connectbyamfam.com/legal/terms-of-use/";
// Contact number
const contactNumber = "800-872-5246";
// Texts
const footerText = `©2010 - ${new Date().getFullYear()} American Family Connect Property and Casualty Insurance Company, Inc. All rights reserved.`;
const title = "Find a Repair Shop";
const description =
  "Our Value in Partnership Program takes the stress out of choosing a repair shop and offers a lifetime workmanship guarantee. \nSearch by city, shop name or ZIP code and connect with a trusted, customer-friendly repair shop near you.";
const noShopsFoundMessage =
  "\nTry searching for another location.\n\nFor immediate repair shop assistance contact claims at " +
  `${contactNumber}`;

export const cahTheme = createMuiTheme({
  palette: {
    primary: {
      main: `${secondaryColor}`,
    },
  },

  custom: {
    colors: {
      primaryColor: `${primaryColor}`,
      secondaryColor: `${secondaryColor}`,
      headerTopBorderColor: `${headerTopBorderColor}`,
      headerBottomBorderColor: `${headerBottomBorderColor}`,
      mainBackgroundColor: `${mainBackgroundColor}`,
      listSelectionBackgroundColor: `${listSelectionColor}`,
      footerBackGroundColor: `${footerColor}`,
      footerTextColor: `${footerTextColor}`,
      footerTopBorderColor: `${footerTopBorderColor}`,
      listItemHoverColor: `${listItemHoverColor}`,
      loadingSpinnerTopColor: `${footerTopBorderColor}`,
      loadingSpinnerBottomColor: `${headerTopBorderColor}`,
      loadingSpinnerHeaderColor: `${headerTopBorderColor}`,
    },
    links: {
      contactUsLink: `${contactUsLink}`,
      logoLink: `${logoLink}`,
      termsAndConditionsLink: `${termsAndConditions}`,
      companyInformation: `${companyInformation}`,
    },
    text: {
      footerText: `${footerText}`,
      title: `${title}`,
      description: `${description}`,
      contactNumber: `${contactNumber}`,
      noShopsFoundMessage: `${noShopsFoundMessage}`,
    },
    styles: {
      headerSpinner: {
        fontFamily: "Oswald",
        fontWeight: 700,
        fontSize: "32px",
        color: `${headerTopBorderColor}`,
      },
      headerSecondary: {
        fontFamily: "Oswald",
        fontWeight: 600,
        fontSize: "22px",
        color: `${headerTopBorderColor}`,
      },
      headerSub: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "19px",
        color: `${headerTopBorderColor}`,
      },
      headerTitle: {
        fontFamily: "Oswald",
        fontWeight: 600,
        fontSize: "28px",
        color: `${headerTopBorderColor}`,
      },
      primaryDescription: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: "#25282A",
      },
      secondaryDescription: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "18px",
        color: "#232323",
      },
      linkText: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: `${primaryColor}`,
        textTransform: "capitalize",
        order: 2,
        "@media (max-width: 480px)": {
          order: 0,
          marginBottom: "13px",
        },
      },
      linkButtonText: {
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "16px",
        color: `${primaryColor}`,
        textTransform: "capitalize",
        order: 2,
        "@media (max-width: 480px)": {
          order: 0,
          marginBottom: "13px",
        },
      },
      hiddenPadding: "24px",
      rowSpan: {
        order: 1,
        flexGrow: 1,
      },
      themeType: {
        currentThemeType: ThemeType.CAH,
      },
      uploadButton: {
        height: "44px",
        textTransform: "uppercase",
      },
      submitButton: {
        order: 0,
        textTransform: "uppercase",
        backgroundColor: `${primaryColor}`,
        color: "#fff",
        fontSize: "1em",
        fontWeight: 700,
        borderRadius: `${searchButtonBorderRadius}`,
        "@media (max-width: 480px)": {
          order: 2,
          width: "100%",
          marginRight: "0px !important",
          marginLeft: "0px !important",
          marginBottom: "13px",
        },
        "&:hover": {
          backgroundColor: `${primaryColor}`,
        },
      },
      iconColor: "#5D7081",
    },
  },
});
